import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import AuthService from "@/services/auth/authService";
import type { LoginRequest } from "@/types/services/auth/auth.type";

const STORAGE_KEY = "user_connected";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    authenticated: localStorage.getItem(STORAGE_KEY) === "true",
    router: useRouter(),
  }),

  actions: {
    setAuthenticated(value: boolean) {
      this.authenticated = value;
      localStorage.setItem(STORAGE_KEY, String(value));
    },
    async login(userData: LoginRequest): Promise<boolean> {
      try {
        await AuthService.login(userData);
        this.setAuthenticated(true);
        this.authenticated = true;
        return true;
      } catch (error) {
        this.setAuthenticated(false);
        this.authenticated = false;
        throw error;
      }
    },

    async logout(): Promise<void> {
      try {
        await AuthService.logout();
      } finally {
        this.setAuthenticated(false);
        this.authenticated = false;
        await this.router.push("/login");
      }
    },
  },
});
